import { takeLatest, call, put, fork, select } from 'redux-saga/effects'

import { indicateProgress } from 'api'
import { userSelector } from 'auth/selectors'
import { verifyGuestCreditCardSuccess } from 'booking/actions'
import { addCreditCardFailed } from 'credit-cards/pagseguro/actions'

import * as creditCardConstants from 'credit-cards/constants'
import * as creditCardActions from 'credit-cards/actions'
import * as creditCardApi from 'credit-cards/grsApi'

import * as constants from 'credit-cards/pagseguro/constants'
import * as api from 'credit-cards/pagseguro/api'

function* pagseguroTokenizationSaga() {
    yield takeLatest(
        constants.ADD_CREDIT_CARD,
        function* ({ customerName, cardNumber, cardExpiryMMYY, cardLastNumbers }) {
            try {
                yield call(indicateProgress, { names: ['pagseguroTokenization'], clearPending: true }, function* () {
                    const user = yield select(userSelector)
                    if (user) {
                        const response = yield call(
                            api.createCCToken,
                            user.token,
                            cardNumber,
                            cardExpiryMMYY,
                            customerName
                        )

                        const cardData = {
                            CardLast4: cardLastNumbers,
                            ccToken: response.ccToken,
                            ExpDate: response.ExpDate,
                            Name: customerName,
                            CardProcessor: 'PAGBANK',
                            CardType: response.CardType,
                        }

                        yield call(creditCardApi.saveCardData, user.token, cardData)
                        yield put(creditCardActions.addPaymentMethodSuccess())
                    }
                    if (!user) {
                        const cardData = {
                            nickName: customerName,
                            cardLastNumbers: cardLastNumbers,
                            maskedPan: cardLastNumbers.slice(-4),
                            cardExpiryMMYY: cardExpiryMMYY,
                            id: 0,
                            token: cardNumber,
                        }
                        yield put(verifyGuestCreditCardSuccess(cardData))
                        yield put(creditCardActions.addPaymentMethodSuccess())
                    }
                })
            } catch (error) {
                yield put(addCreditCardFailed(error.message))
            }
        }
    )
}

function* pagseguroPaymentSaga() {
    yield takeLatest(creditCardConstants.INIT_PAYMENT, function* () {
        yield put(creditCardActions.paymentSuccess())
    })
}

export function* rootSaga() {
    yield fork(pagseguroTokenizationSaga)
    yield fork(pagseguroPaymentSaga)
}
